import emptyFunction from 'react-utils/emptyFunction';
import { getReferenceLabel, getProperty } from 'reporting-data/v2/dataset/datasetTypes';
import { StandardSankeyColors } from './colors';
const FALLBACK_DELIMITER = ';<br/>';
export const getNodeLabels = (dataset, {
  originField,
  destinationField
}) => {
  const getLabelsFromProperty = field => {
    const property = getProperty(dataset, field);
    return Object.keys(property.references).reduce((labelMap, value) => Object.assign({}, labelMap, {
      [value]: getReferenceLabel(dataset, field, value)
    }), {});
  };
  const fromLabels = getLabelsFromProperty(originField);
  const toLabels = getLabelsFromProperty(destinationField);
  return Object.assign({}, fromLabels, toLabels);
};
const applyColor = node => Object.assign({}, node, {
  color: StandardSankeyColors[node.column % StandardSankeyColors.length]
});
export const getHighchartNodes = (dataset, {
  columns,
  originField,
  destinationField,
  hideOriginNode,
  measures: {
    destinationNodeTotal
  }
}) => {
  const originBasedNodeIndexModifier = hideOriginNode ? 0 : 1;
  const firstHighchartNode = {
    column: -1 + originBasedNodeIndexModifier,
    id: dataset.data[0][originField],
    name: getReferenceLabel(dataset, destinationNodeTotal, dataset.data[0][destinationNodeTotal])
  };
  const highchartNodesByLayout = columns.flatMap((column, columnIdx) => column.nodes.map(node => {
    const dataNode = dataset.data.find(item => item[destinationField] === node.id);
    return {
      column: columnIdx + originBasedNodeIndexModifier,
      id: dataNode[destinationField],
      name: getReferenceLabel(dataset, destinationNodeTotal, dataNode[destinationNodeTotal])
    };
  }));
  return [firstHighchartNode, ...highchartNodesByLayout].map(applyColor);
};
const createColumnLabelGetter = (dataset, columnLabelField) => {
  const columnLabelProperty = columnLabelField && getProperty(dataset, columnLabelField);
  const columnLabelOptions = columnLabelProperty && columnLabelProperty.format && columnLabelProperty.format.options;
  return columnLabelOptions ? key => {
    const option = columnLabelOptions[key];
    return option && option.label;
  } : emptyFunction;
};
export const getColumnHeaders = (dataset, layout, nodeLabels, originNodeId) => {
  const getColumnLabel = createColumnLabelGetter(dataset, layout.columnLabelField);
  const columnHeadersByLayout = layout.columns.map((column, index) => getColumnLabel(index) || column.nodes.map(node => nodeLabels[node.id]).join(FALLBACK_DELIMITER));
  return layout.hideOriginNode ? columnHeadersByLayout : [nodeLabels[originNodeId], ...columnHeadersByLayout];
};